<app-block-wrapper [_editable]="_editable" [style]="style">
  <h1
    *ngIf="type === 'h1'"
    class="size-{{ size }} {{ alignment }} a-m-{{ mobileAlignment }} a-t-{{ tabletAlignment }} a-d-{{
      desktopAlignment
    }}"
    [style.--large-desktop-size]="
      size === 'custom' && customLargeDesktopSize ? customLargeDesktopSize + 'px' : undefined
    "
    [style.--desktop-size]="size === 'custom' && customDesktopSize ? customDesktopSize + 'px' : undefined"
    [style.--tablet-size]="size === 'custom' && customTabletSize ? customTabletSize + 'px' : undefined"
    [style.--mobile-size]="size === 'custom' && customMobileSize ? customMobileSize + 'px' : undefined"
    [style.--mobile-line-height]="size === 'custom' ? customMobileLineHeight : undefined"
    [style.--tablet-line-height]="size === 'custom' ? customTabletLineHeight : undefined"
    [style.--desktop-line-height]="size === 'custom' ? customDesktopLineHeight : undefined"
    [style.--large-desktop-line-height]="size === 'custom' ? customLargeDesktopLineHeight : undefined"
  >
    {{ title || 'EMPTY TITLE COMPONENT' | replaceText : replacer }}
  </h1>
  <h2
    *ngIf="type === 'h2'"
    class="size-{{ size }} {{ alignment }} a-m-{{ mobileAlignment }} a-t-{{ tabletAlignment }} a-d-{{
      desktopAlignment
    }}"
    [style.--large-desktop-size]="
      size === 'custom' && customLargeDesktopSize ? customLargeDesktopSize + 'px' : undefined
    "
    [style.--desktop-size]="size === 'custom' && customDesktopSize ? customDesktopSize + 'px' : undefined"
    [style.--tablet-size]="size === 'custom' && customTabletSize ? customTabletSize + 'px' : undefined"
    [style.--mobile-size]="size === 'custom' && customMobileSize ? customMobileSize + 'px' : undefined"
    [style.--mobile-line-height]="size === 'custom' ? customMobileLineHeight : undefined"
    [style.--tablet-line-height]="size === 'custom' ? customTabletLineHeight : undefined"
    [style.--desktop-line-height]="size === 'custom' ? customDesktopLineHeight : undefined"
    [style.--large-desktop-line-height]="size === 'custom' ? customLargeDesktopLineHeight : undefined"
  >
    {{ title || 'EMPTY TITLE COMPONENT' | replaceText : replacer }}
  </h2>
  <h3
    *ngIf="type === 'h3'"
    class="size-{{ size }} {{ alignment }}  a-m-{{ mobileAlignment }} a-t-{{ tabletAlignment }} a-d-{{
      desktopAlignment
    }}"
    [style.--large-desktop-size]="
      size === 'custom' && customLargeDesktopSize ? customLargeDesktopSize + 'px' : undefined
    "
    [style.--desktop-size]="size === 'custom' && customDesktopSize ? customDesktopSize + 'px' : undefined"
    [style.--tablet-size]="size === 'custom' && customTabletSize ? customTabletSize + 'px' : undefined"
    [style.--mobile-size]="size === 'custom' && customMobileSize ? customMobileSize + 'px' : undefined"
    [style.--mobile-line-height]="size === 'custom' ? customMobileLineHeight : undefined"
    [style.--tablet-line-height]="size === 'custom' ? customTabletLineHeight : undefined"
    [style.--desktop-line-height]="size === 'custom' ? customDesktopLineHeight : undefined"
    [style.--large-desktop-line-height]="size === 'custom' ? customLargeDesktopLineHeight : undefined"
  >
    {{ title || 'EMPTY TITLE COMPONENT' | replaceText : replacer }}
  </h3>
</app-block-wrapper>
